import * as constants from '../../../constants';
import { Helper } from '../Helper';
export class ReturnHelper extends Helper {
    emit(sb, node, options) {
        const finallyPC = options.finallyPC;
        if (finallyPC === undefined) {
            sb.emitPushInt(node, constants.NORMAL_COMPLETION);
            sb.emitOp(node, 'RET');
        }
        else {
            sb.emitPushInt(node, constants.NORMAL_COMPLETION);
            sb.emitPushInt(node, constants.FINALLY_COMPLETION);
            sb.emitJmp(node, 'JMP', finallyPC);
        }
    }
}

//# sourceMappingURL=ReturnHelper.js.map
